import Immutable from 'immutable';

export const BLUEPRINT_DROPDOWN_TOGGLE_PROPS = Immutable.fromJS({
    icon: 'more_horiz',
    size: 'sm',
    'data-testid': 'blueprint-dropdown',
});

export enum DROPDOWN_ACTIONS {
    CREATE = 'create',
    EDIT_BASE_VIDEO = 'edit_base_video',
    COPY_TO = 'copy_to',
    COPY_TO_MULTIPLE = 'copy_to_multiple',
    DELETE = 'delete',
}
